<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col cols="8" lg="6">
          <b-card-group>
            <b-card no-body class="p-2">
              <b-card-body>
                <b-form name="login">
                  <div class="text-center">
                    <img v-if="!usePassowrd" style="width: 67%; max-height: 80px; object-fit: contain; margin-top:-2em;"
                      src="/images/apply-logo.jpg" />
                  </div>

                  <!-- <p v-show="!isLoginFailed" class="text-muted">
                    {{ $t('auth.login_description') }}
                  </p> -->
                  <p v-show="isLoginFailed" class="text-danger">{{ $t('auth.failed') }}</p>
                  <b-input-group class="mb-2" v-if="usePassowrd">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user" /></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input ref="email" @keydown.enter.native="attemptLogin" v-model="email" type="text"
                      class="form-control" :placeholder="$dt('global.email', 'your@email.com')"
                      autocomplete="username-email" />
                  </b-input-group>
                  <b-input-group class="mb-2" v-if="usePassowrd">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input @keydown.enter.native="attemptLogin" name="password" v-model="password" type="password"
                      class="form-control" :placeholder="$dt('global.password', 'password..')"
                      autocomplete="current-password" />
                  </b-input-group>
                  <b-input-group class="mb-3" v-if="usePassowrd || canGoogleOauth">
                    <b-form-checkbox name="remember" v-model="remember" class="">
                      {{ $dt('global.remember', 'Remember me on this device') }}
                    </b-form-checkbox>
                  </b-input-group>
                  <b-row>
                    <b-col cols="12" class="text-left mt-2 d-none d-md-block">
                      <b-button-group class="d-flex">
                        <!-- <LanguagesDropdown/> -->
                        <b-button name="login" block variant="primary" class="w-100" @click="attemptLogin()"
                          v-if="usePassowrd" :disabled="isLoading">{{ $dt('auth.login', 'Login') }}</b-button>
                        <b-button block variant="outline-primary" class="px-4 w-100 my-0" @click="usePassowrd = true"
                          v-if="!usePassowrd">{{ $dt('auth.login_using_password', 'Use password') }}</b-button>
                        <div id="google-btn"></div>
                      </b-button-group>
                    </b-col>
                    <b-col cols="12" class="text-left mt-2 d-md-none">
                      <b-button-group class="d-flex" vertical>
                        <!-- <LanguagesDropdown/> -->
                        <b-button name="login" block variant="primary" class="w-100" @click="attemptLogin()"
                          v-if="usePassowrd" :disabled="isLoading">{{ $dt('auth.login', 'Login') }}</b-button>
                        <b-button block variant="outline-primary" class="px-4 w-100 my-0" @click="usePassowrd = true"
                          v-if="!usePassowrd">{{ $dt('auth.login_using_password', 'Use password') }}</b-button>
                        <b-button variant="outline-success" v-if="canGoogleOauth" @click="useAuthProvider('google')"
                          class="oauth-btn px-4">
                          <img src="/img/google-logo.svg" />
                          <span>{{ $dt('auth.login_google', 'Use google') }}</span>
                        </b-button>
                      </b-button-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="text-left mt-2 d-none d-lg-block">
                      <!-- <b-col cols="12" class="text-left mt-2"> -->
                      <b-button-group class="d-flex external_sys_links">
                        <b-button variant="outline-primary"
                          href="https://applyit.atlassian.net/jira/dashboards/last-visited">
                          <img src="@/assets/jira_logo.png" />
                          <!-- {{ $dt('external_system.jira', 'Jira') }} -->
                        </b-button>
                        <b-button variant="outline-warning" href="https://gitlab.com/applyitlv">
                          <img src="@/assets/gitlab_logo.png" />
                          <!-- {{ $dt('external_system.gitlab', 'Gitlab') }} -->
                        </b-button>
                        <b-button variant="outline-danger" href="https://applyit.slack.com">
                          <img src="@/assets/slack_logo.png" />
                        </b-button>
                        <b-button variant="outline-info" href="https://wiki.applyit.lv">
                          <img src="@/assets/wikijs_logo.png" />
                        </b-button>
                      </b-button-group>
                    </b-col>
                    <b-col cols="12" class="text-left mt-2 d-lg-none external_sys_links icons_left">
                      <b-button-group class="d-flex " vertical>
                        <b-button variant="primary" href="https://applyit.atlassian.net/jira/dashboards/last-visited">
                          <img src="@/assets/jira_logo.png" />
                          {{ $dt('external_system.jira', 'Jira') }}
                        </b-button>
                        <b-button variant="warning" href="https://gitlab.com/applyitlv">
                          <img src="@/assets/gitlab_logo.png" />
                          {{ $dt('external_system.gitlab', 'Gitlab') }}
                        </b-button>
                        <!-- <b-button variant="primary" href="https://applyit.atlassian.net/wiki/spaces/">
                          <img src="@/assets/confluence_logo.png" />
                          {{ $dt('external_system.confluence', 'Confluence') }}
                        </b-button> -->
                        <b-button variant="danger" href="https://applyit.slack.com">
                          <img src="@/assets/slack_logo.png" />
                          {{ $dt('external_system.slack', 'Slack') }}
                        </b-button>
                        <b-button variant="info" href="https://wiki.applyit.lv">
                          <img src="@/assets/wikijs_logo.png" />
                          {{ $dt('external_system.wikijs', 'Wiki') }}
                        </b-button>
                      </b-button-group>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col cols="6" class="text-left">
                      <b-button variant="link" class="px-0"
                                :to="{ name: 'Register' }">{{ $t('auth.register_link') }}</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                                :to="{ name: 'PasswordForgot' }">
                        {{ $t('auth.forgot_password_link')}}
                      </b-button>
                    </b-col>
                  </b-row> -->
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';
// import LanguagesDropdown from '@/containers/Dropdowns/LanguagesDropdown';
// import { Providers/* , Google,  Facebook, Google , Twitter */ } from 'universal-social-auth';

export default {
  mounted() {
    if (this.$refs.email) this.$refs.email.$el.focus();

    // Loading Google Client id
    // eslint-disable-next-line no-undef
    google.accounts.id.initialize({
      client_id: window.ENV.VUE_APP_OAUTH_GOOGLE_CLIENT_ID,
      callback: this.handleCredentialResponse
    });
    // To enable pop up authentification
    // eslint-disable-next-line no-undef
    google.accounts.id.prompt();
    // eslint-disable-next-line no-undef
    google.accounts.id.renderButton(
      document.getElementById('google-btn'),
      {
        theme: 'outline', size: 'large'
      }
    );
  },
  data() {
    return {
      usePassowrd: false,
      canGoogleOauth: !!window.ENV.VUE_APP_OAUTH_GOOGLE_CLIENT_ID,
      email: '',
      password: '',
      remember: false,
      remember_name: navigator.userAgent,

      isLoading: false,
      isLoginFailed: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters('Auth', ['user']),
  },
  methods: {
    ...mapActions('Auth', [VT.LOGIN]),
    attemptLogin() {
      // this is with credentials
      this.login(this.$data);
    },
    login(data) {
      this.isLoginFailed = false;
      this.isLoading = true;
      this[VT.LOGIN](data).then(() => {
        const redirectPath = sessionStorage.getItem('redirectPath');
        if (redirectPath) {
          sessionStorage.removeItem('redirectPath');
          this.$router.replace({ path: redirectPath });
        } else {
          this.$router.replace({ name: 'Dashboard' });
        }
      }).catch(() => {
        this.isLoginFailed = true;
        this.isLoading = false;
      });
    },
    handleCredentialResponse(response) {
      this.login({
        provider: 'google', token: response.credential, remember: this.remember, remember_name: this.remember_name, oauth: true
      }).catch(() => {
        console.log('Oauth canceled or failed');
      });
    },
  }
};
</script>
<style lang=scss >
button.oauth-btn {
  padding: 0.2em 0 !important;
  white-space: normal;
  min-width: 135px;

  img {
    max-height: 1.4em;
    padding-right: 0.2em;
    vertical-align: -0.3em;
  }
}

.external_sys_links {
  .btn {
    padding: 0.3em 0 0.4em 0 !important;
  }

  img {
    max-height: 20px;
  }

  &.icons_left img {
    float: left;
    margin-left: 0.3em;
  }
}
</style>
